export interface UnsellableMovementRow {
  id: string
  /** Server record id when returned from `/api/InventoryMovement/Save` (for updates). */
  apiId?: number
  code: string
  warehouseId: string
  warehouseName: string
  itemId: string
  itemLabel: string
  batchId: string
  batchLabel: string
  previousQuantity: number
  damaged: number
  expired: number
  newQuantity: number
  movementDate: string
}

export function nextUnsellableCode(existing: UnsellableMovementRow[]): string {
  let max = 0
  for (const r of existing) {
    const m = /^USM-(\d+)$/.exec(r.code)
    if (m) max = Math.max(max, Number(m[1]))
  }
  return `USM-${String(max + 1).padStart(5, '0')}`
}
